import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { immediateAccess, methodSteps } from '../../data/content';
export function AlsoGet() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" aria-labelledby="alsoget-title" data-id="element-102" data-mp="347chve6aytle">
      <div className="mx-auto max-w-5xl" data-id="element-103" data-mp="2ze01tsfovv49">
        <div id="alsoget-title" data-id="element-104" data-mp="3d66kbl6bee6v">
          <SectionHeading eyebrow="You’ll also get immediate access to" title="The tools that make the method usable in the room" data-id="element-105" data-mp="3d5eme3p8w4df" />
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-106" data-mp="3n55gw5dt2jdi">
          {immediateAccess.map((item, index) => <div key={item.title} className={`flex flex-col rounded-2xl border border-navy/10 bg-cream p-5 sm:p-6 ${index === 0 ? 'md:col-span-2 md:bg-blush' : ''}`} data-id="element-107" data-mp="3i6u7fvrfaavt" data-mpi={index}>
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-108" data-mp="1nu4fhjkm7br2">
                {item.emoji}
              </span>
              <h3 className="mt-3 font-display text-[19px] font-bold leading-tight text-navy sm:text-[22px]" data-id="element-109" data-mp="2dx7800sybxm0">
                {item.title}
              </h3>
              <p className="mt-2 text-[14.5px] leading-relaxed text-navy/70 sm:text-[15.5px]" data-id="element-110" data-mp="2hxr7vc4wtfbu">
                {item.text}
              </p>
              {index === 0 ? <div className="mt-4 flex flex-wrap items-center gap-1.5" data-id="element-111" data-mp="2ro2amvcuxih5">
                  {methodSteps.map((step, stepIndex) => <React.Fragment key={step} data-id="element-112" data-mp="2wq1ee6ciehem" data-mpi={stepIndex}>
                      {stepIndex > 0 ? <ArrowRightIcon className="h-3.5 w-3.5 shrink-0 text-rose/50" aria-hidden="true" data-id="element-113" data-mp="31kx7zaxe9ctu" /> : null}
                      <span className="rounded-lg bg-white px-2.5 py-1.5 text-[11.5px] font-extrabold uppercase tracking-wide text-rose" data-id="element-114" data-mp="17bd54dz7tfkt">
                        {step}
                      </span>
                    </React.Fragment>)}
                </div> : null}
            </div>)}
        </div>

        <div className="mt-10 rounded-3xl border-2 border-rose/20 bg-blush p-6 sm:p-9" data-id="element-115" data-mp="2nmg0a2drggz5">
          <h3 className="font-display text-[22px] font-bold leading-tight text-navy sm:text-[28px]" data-id="element-116" data-mp="2jk2vbg6u8n3f">
            The next menopause patient shouldn’t require you to start from zero.
          </h3>
          <p className="mt-4 text-[12px] font-extrabold uppercase tracking-[0.12em] text-rose" data-id="element-117" data-mp="2slsmqm0pzm17">
            You should know:
          </p>
          <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-118" data-mp="379nh06udlyge">
            {['Where to start.', 'What to review.', 'Which decision you’re trying to make.', 'What information you need before moving forward.', 'How to structure follow-up.'].map(item => <li key={item} className="rounded-xl bg-white px-4 py-3 text-[14.5px] font-semibold text-navy" data-id="element-119" data-mp="3uxkaiek42qb2">
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-120" data-mp="3lvubamjzmn2q">
          <CtaButton label="I want access to the complete system" subtext="Instant access · One-time $27 · Lifetime access" data-id="element-121" data-mp="3lz89rjpj6c4w" />
        </div>
      </div>
    </section>;
}